import {
    FilterData,
    FilterBlockTypesEnum,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Select,
            name: "status",
            multiple: true,
            options: [
                {
                    value: "SERVICE_CALL_Open",
                },
                {
                    value: "SERVICE_CALL_Deleted",
                },
                {
                    value: "SERVICE_CALL_Closed",
                },
                {
                    value: "SERVICE_CALL_WaitingForCustomer",
                },
                {
                    value: "SERVICE_CALL_InProcess",
                },
                {
                    value: "SERVICE_CALL_call-predictive",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            name: "machine",
            multiple: true,
            options: [
                { value: "TRUMPF MACHINE 1" },
                { value: "TRUMPF MACHINE 2" },
                { value: "TRUMPF MACHINE 3" },
                { value: "TRUMPF MACHINE 4" },
                { value: "TRUMPF MACHINE 5" },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            name: "ersteller",
            multiple: true,
            options: [
                { value: "Max Mustermann" },
                { value: "Max Mustermann 2" },
                { value: "Max Mustermann 3" },
                { value: "Max Mustermann 4" },
                { value: "Max Mustermann 5" },
            ],
        }
    ],
};

const writeToFile = (object: FilterData, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "myservicecalls-stateful-filter");
